<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../components/screen";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import Area from "@/components/c-input-area";
import Dropzone from "@/components/c-dropzone";
import Select from "@/components/c-select";
import Search from "@/components/c-select-search";
import List from "../../../components/list";
import Loading from "@/components/c-loading";
import { bookingService } from "../../../services/bookingservice/booking.service";
import { bookingpaymentService } from "../../../services/bookingservice/bookingpayment.service";
import { propertyService } from "../../../services/propertyservice/property.service";
import { servicehelpers } from "../../../services/servicehelpers";
import i18n from "../../../i18n";

/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Booking Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    Button,
    Input,
    Area,
    Dropzone,
    Select,
    Search,
    List
  },
  watch: {
      dataDiscount: function(newVal) { // watch it
        console.log(newVal);
        this.changeSellPrice();
      }
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "Booking",
      breadCrumb: {},
      currency: "",
      project: 0,

      bookingData: null,
      bankAccountData: {},
      customerData: {},
      templeteData: {},
      projectData: {},
      discountTypeData: {},
      accountTenderData: {},
      accountBookingData: {},
      propertyData: {},
      sellerData: {},
      currencyData: {},
      commissionTypeData: {},
      paymentMethodData: {},
      accountCommissionExpenseData: {},
      accountCommissionPaidData: {},
      dataDiscountText: '',
      dataProject: 0,
      dataLastProject: 0,
      propertySelected: {},
      dataBookingPayments: {},
      user: JSON.parse(localStorage.getItem('user')),
      seller: JSON.parse(localStorage.getItem('seller')),

      dataCode: '',
      dataCustomer: 0,
      dataTemplate: 0,
      dataPaymentAccount: 0,
      dataBankAccount: 0,
      dataCurrency: 0,
      dataBookingAccount: 0,
      dataProperty: 0,
      dataAmount: 0,
      dataPaymentMethod: 1,
      dataDiscount: 0,
      dataDiscountType: 0,
      dataSalePrice: 0,
      dataExpireDate: this.$moment().add(7, 'days').format('YYYY-MM-DD'),
      dataBookingAmount: 0,
      dataSaleUser: 0,
      dataCommission: 0,
      dataCommissionAmount: 0,
      dataCommissionExpenseAccount: 0,
      dataCommissionPaidAccount: 0,
      dataNotation: '',
      dataDoc: [],
      dataDate: this.$moment().clone().format('YYYY-MM-DD'),

    };
  },
  mounted() {
    
    this.loadingCurrencyData();
    this.loadingDiscountTypeData();

    let hasId = 'id' in this.$route.params;
    this.dataDiscountType = 2;
    this.dataDiscountText = "សា​ច់ប្រាក់";
    this.dataProject = 1;
    this.dataCurrency = 1;
    this.dataSeller = this.user && this.user.type_id == 1 ? this.user.id : 0;
    this.isAdd = this.fetchingStats = !hasId;

    if(hasId) {
      this.loadingData(this.$route.params.id);     

    } else if('propertyid' in this.$route.query) {
      this.loadingPropertyDataById(this.$route.query.propertyid);
    }  else {
       this.loadingData(0);
    }
  },

  methods: {
    loadingData: function(id) {
      this.fetchingStats = false;
      bookingService.getOne(id)
        .then(response => {

          this.fetchingStats = true;
          if(response.data) {
            this.breadCrumb = {
              text: response.data.name + " - (" + response.data.code + ")",
              active: true,
            };
          
            this.bookingData = response;

            this.dataCode = this.bookingData.data.code;
            this.dataDate = this.bookingData.data.booking_date;
            this.dataCustomer = this.bookingData.data.customer_id;
            this.dataTemplate = this.bookingData.data.template_id;
            this.dataAccountTender = this.bookingData.data.payment_account_id;
            this.dataAccountBooking = this.bookingData.data.booking_account_id;
            this.dataProperty = this.bookingData.data.property_id;
            this.dataAmount = this.bookingData.data.amount;
            this.dataCurrency = this.bookingData.data.currency_id;
            this.dataExpired = this.bookingData.data.expire_date;
            this.dataDeposit = this.bookingData.data.booking_amount;
            this.dataSeller = this.bookingData.data.sale_user_id;
            this.dataCommissionAmount = this.bookingData.data.commission_amount;
            this.dataCommission = this.bookingData.data.commission_id;
            this.dataAccountCommissionExpense = this.bookingData.data.commission_expense_account_id;
            this.dataAccountCommissionPaid = this.bookingData.data.commission_paid_account_id;
            this.dataNotation = this.bookingData.data.notation;
            this.dataPaymentMethod = this.bookingData.data.payment_method_id;

            this.dataDiscount = this.bookingData.data.discount;
            this.dataDiscountType = this.bookingData.data.discount_type;
            this.dataSalePrice = this.bookingData.data.sale_price;
            this.dataBookingAmount = this.bookingData.data.booking_amount;
            this.dataExpireDate = this.bookingData.data.expire_date;


            this.loadingDataPayment(this.bookingData.data.id);

            
            this.bookingData.data.collections.map(item => {
              if('booking_attachments' in item) {
                this.dataDoc = item.booking_attachments;
              }
            });
          }

          this.loadingSettings(response.setting);
        
        });
    },

    loadingPropertyData: function(projectId = 0) {
      propertyService.getDropdowns(projectId).then(response => {
        this.propertyData = response;
      });
    },

    loadingPropertyDataById: function(id) {

      //let param = id == 0 ? '?page=0' : `?page=0&clause={"clause":[{"conjuction":"and","properties.id":{"value":${id}}}]}`;
      this.fetchingStats = false;
      propertyService.getOne(id)
        .then(response => {
          this.propertyData = response;

          this.propertySelected = response.data;
          this.dataProperty = response.data.id;
          this.dataAmount = response.data.price;
          this.dataSalePrice = response.data.price;

          this.fetchingStats = true;
          this.loadingSettings(response.setting);

      });
      
    },

    loadingCurrencyData: function() {

      servicehelpers.getCurrencyData().then(response => {
        this.currencyData = response;
      });
    },
    loadingDiscountTypeData: function() {
      servicehelpers.getDiscountTypeData().then(response => {
        this.discountTypeData = response;
      });
    },

    loadingSettings: function(setting) {

      this.customerData = {data: setting.customers};
      this.projectData = {data: setting.projects};
      this.propertyData = {data: setting.properties};
      this.paymenttermData  = {data: setting.paymentterms};
      this.commissionTypeData = {data: setting.commissiontypes};
      this.templeteData = {data: setting.templates.filter((item) => item.contract_type_id == 3)};
      this.paymentMethodData = {data: setting.paymentmethods.filter((item) => item.id <= 3)};
      this.bankAccountData = {data: setting.bankaccounts};

      // console.log(setting);
    },

    loadingDataPayment: function(id) {
      // this.fetchingStats = false;
      bookingpaymentService.getListByBooking(id)
        .then(response => {

          // this.fetchingStats = true;
          if(response.data) {
            this.dataBookingPayments = response;
          }
        
        });
    },

    submitCancel: function() {

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "booking-list"
          });

        }
      });

      // console.log(this.dataProperty);

      
    },
    submitSave: function() {

      if(!this.dataCustomer && this.dataCustomer == 0) {
        this.$swal.fire({
          title: i18n.t('general.required.title'),
          text: i18n.t('customer.text') + i18n.t('general.required.message'),
          icon: "error",
          confirmButtonColor: "#34c38f",
          confirmButtonText: i18n.t('general.success.yes')
        });
        return;
      } else if(!this.dataProperty && this.dataProperty == 0) {
        this.$swal.fire({
          title: i18n.t('general.required.title'),
          text: i18n.t('property.text') + i18n.t('general.required.message'),
          icon: "error",
          confirmButtonColor: "#34c38f",
          confirmButtonText: i18n.t('general.success.yes')
        });
        return;
      } else if(!this.dataTemplate && this.dataTemplate == 0) {
        this.$swal.fire({
          title: i18n.t('general.required.title'),
          text: i18n.t('booking.contract-template') + i18n.t('general.required.message'),
          icon: "error",
          confirmButtonColor: "#34c38f",
          confirmButtonText: i18n.t('general.success.yes')
        });
        return;
      } else if(!this.dataBookingAmount && this.dataBookingAmount == 0) {
        this.$swal.fire({
          title: i18n.t('general.required.title'),
          text: i18n.t('booking.deposit') + i18n.t('general.required.message'),
          icon: "error",
          confirmButtonColor: "#34c38f",
          confirmButtonText: i18n.t('general.success.yes')
        });
        return;
      }

      this.tryingToSubmit = true;

      let booking = {
        code: this.dataCode,
        customer_id: this.dataCustomer,
        template_id: this.dataTemplate,
        payment_account_id: this.dataPaymentAccount,
        currency_id: this.dataCurrency,
        booking_account_id: this.dataBookingAccount,
        property_id: this.dataProperty,
        amount: this.dataAmount,
        discount: this.dataDiscount,
        discount_type: this.dataDiscountType,
        sale_price: this.dataSalePrice,
        booking_date: this.dataDate, // this.$moment().format('YYYY-MM-DD'),
        expire_date: this.dataExpireDate,
        booking_amount: this.dataBookingAmount,
        payment_method_id: this.dataPaymentMethod,
        sale_user_id: this.seller ? this.seller.id : 0, //this.dataSaleUser,
        commission_id: this.dataCommission,
        commission_amount: this.dataCommissionAmount,
        commission_expense_account_id: this.dataCommissionExpenseAccount,
        commission_paid_account_id: this.dataCommissionPaidAccount,
        notation: this.dataNotation,
        booking_attachments: this.dataDoc,
        bank_account_id: this.dataBankAccount,
        property_status_id: 2

      };

      //console.log(this.dataProperty, this.dataCustomer, JSON.stringify(booking));
      

      
      if(this.isAdd) {
        bookingService.insert(booking)
         .then(response => {

          console.log(response.status, JSON.stringify(booking));

           this.tryingToSubmit = false;

           if(response.status == 200) {
              this.clearForm();
              this.$swal.fire({
                title: i18n.t('general.success.title'),
                text: i18n.t('general.success.message'),
                icon: "success",
                confirmButtonColor: "#34c38f",
                confirmButtonText: i18n.t('general.success.yes')
              }).then(result => {
                if (!result.value) {
                  this.$router.push(this.$route.query.redirectFrom || {
                    name: "booking-list"
                  });
                }
              });
           }
          
        });
      } else {
        //console.log(JSON.stringify(booking));
        console.log("Else");
        bookingService.update(this.$route.params.id, booking)
         .then(response => {
          this.tryingToSubmit = false;

          if(response.status == 200) {
            this.$router.push(this.$route.query.redirectFrom || {
              name: "booking-list"
            });

            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message-edit'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
      }
    },

    clearForm: function() {
      this.dataCode = '';
      this.dataCustomer = 0;
      this.dataTemplate = 0;
      this.dataPaymentAccount = 0;
      this.dataCurrency = 0;
      this.dataBookingAccount = 0;
      this.dataProperty = 0;
      this.dataAmount = 0;
      this.dataDiscount = 0;
      this.dataDiscountType = 0;
      this.dataSalePrice = 0;
      this.dataExpireDate = '';
      this.dataBookingAmount = 0;
      this.dataSaleUser = 0;
      this.dataCommission = 0;
      this.dataCommissionAmount = 0;
      this.dataCommissionExpenseAccount = 0;
      this.dataCommissionPaidAccount = 0;
      this.dataNotation = '';
      this.dataDoc = [];
    },

    currencyChanged: function(event) {

      const cur = this.currencyData.data.find(obj => {
        return obj.id === event
      });

      this.currency = cur == null ? "" : cur.name_en;
    
    },
    paymentMethodChanged: function(event) {

      if(event != 2 && event != 3) {
        this.dataBankAccount = 0;
      }
    }, 
    projectChanged: function(event) {
      this.project = event;

      if(this.dataLastProject != 0) {
        this.loadingPropertyData(this.project);
        // console.log(event);
      }

      this.dataLastProject = event;
    },
    propertyChanged: function(property) {
      // console.log(property);
      this.dataAmount = property ? property.price : 0;

      if(this.dataDiscountType == 2) {
        this.dataSalePrice = property ? property.price - this.dataDiscount : 0;
      } else {
        this.dataSalePrice = property ? property.price - (this.dataDiscount * this.dataAmount / 100): 0;
      }

      
    },
    uploadDocSuccess(file, response) {
        console.log(file);
        this.dataDoc.push({
          path: response.data
        });
    },
    discountTypeChanged: function(event) {

      const discountType = this.discountTypeData.data.find(obj => {
        return obj.id === event
      });

      this.dataDiscountText = discountType == null ? "" : discountType.name;

      // console.log(this.dataDiscountText);
      this.changeSellPrice();
    }, 

    changeSellPrice: function() {
      if(this.dataDiscountType == 2) {
        this.dataSalePrice = this.dataAmount - this.dataDiscount;
      } else {
        this.dataSalePrice = this.dataAmount - (this.dataDiscount * this.dataAmount / 100);
      }
    },

    deleted: function(id) {
      bookingpaymentService.remove(id)
        .then(response => {
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
    },

    isMoreBooking: function() {

      if(Object.keys(this.dataBookingPayments).length === 0) {
        return false;
      } else {
        return this.dataBookingPayments.data.length > 1;
      }
    },
  }
};
</script>

<template>
  <Layout>
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('booking.list'),
        href: '/general/booking',
      }, {
        text: $t('booking.new'),
        active: true
      }]" :title="this.isAdd ? $t('booking.new') : $t('booking.edit')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('booking.list'),
        href: '/general/booking',
      }, this.breadCrumb]" :title="this.isAdd ? $t('booking.new') : $t('booking.edit')" />
    </div>
    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
              <div class="row">
                <h4 class="card-title">{{$t('booking.text')}}</h4>
                <p class="mb-4">{{$t('booking.sub-text')}}</p>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <Input 
                    :type="'text'"
                    :id="'code'"
                    :disabled="true"
                    v-model="dataCode"
                    :label="'booking.code'"
                     /> 
                </div>
                <div class="col-md-6">
                  <Select 
                    :text="'name'"
                    :id="'template_id'"
                    v-model="dataTemplate"
                    :list="this.templeteData"
                    :label="'booking.contract-template'"
                    :require="true"
                     /> 
                </div>
              </div>
              <div class="row">
                
                <div class="col-md-6">
                  <Input 
                    :type="'date'"
                    :id="'booking_date'"
                    v-model="dataDate"
                    :label="'general.date'"
                    :require="true"
                     />
                </div>
                <div class="col-md-6">
                  <Search 
                    :id="'customer_id'"
                    v-model="dataCustomer"
                    :list="this.customerData"
                    :require="true"
                    :label="'customer.text'"  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <Select
                    @change="paymentMethodChanged" 
                    :id="'payment_method_id'"
                    :auto="true"
                    v-model="dataPaymentMethod"
                    :list="this.paymentMethodData"
                    :label="'booking.payment-method'"
                     /> 
                </div>
                <div v-show="dataPaymentMethod == 2 || dataPaymentMethod == 3" class="col-md-6">
                  <Select
                    :id="'bank_account_id'"
                    v-model="dataBankAccount"
                    :list="this.bankAccountData"
                    :label="'payment.bank_account'"
                     /> 
                </div>
              </div>
              <div class="row">
                <div class="mb-1"><hr/></div>
                <h4 class="card-title">{{$t('booking.booking-property')}}</h4>
                <p class="mb-4"> {{$t('booking.sub-booking-property')}}</p>
              </div>
               <div class="row">
                 <div class="col-md-4">
                  <Select
                    @change="projectChanged" 
                    :id="'project_id'"
                    :auto="true"
                    :editable="false"
                    v-model="dataProject"
                    :list="this.projectData"
                    :label="'property.project'"
                     /> 
                </div>
                
                <div class="col-lg-4">
                  <Search 
                    @change="propertyChanged" 
                    :id="'property_id'"
                    :editable="false"
                    v-model="dataProperty"
                    :list="this.propertyData"
                    :require="true"
                    :label="'property.text'"  />
                </div>
                <div class="col-md-4">
                  <Select
                    @change="currencyChanged" 
                    :id="'currency_id'"
                    :auto="true"
                    :text="'name'"
                    :text2="'name_en'"
                    :editable="false"
                    v-model="dataCurrency"
                    :list="this.currencyData"
                    :label="'property.currency'"
                     /> 
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4">
                  <Input 
                    :type="'number'"
                    :id="'amount'"
                    :disabled="true"
                    v-model="dataAmount"
                    :last="currency"
                    :label="'booking.price'" />
                </div>
                <div class="col-lg-4">
                   <Input 
                        :type="'number'"
                        :id="'discount'"
                        v-model="dataDiscount"
                        :last="this.dataDiscountText"
                        :label="'booking.discount'"  />
                </div>
                <div class="col-lg-4">
                  <Select
                        :id="'discount_type'"
                        :text="'name'"
                        :auto="true"
                        v-model="dataDiscountType"
                        :list="this.discountTypeData"
                        @change="discountTypeChanged" 
                        :label="'booking.as'"
                        />
                </div>
                                
              </div>
              <div class="row">
                <div class="col-lg-4">
                  <Input 
                    :type="'number'"
                    :id="'sale_price'"
                    v-model="dataSalePrice"
                    :last="currency"
                    :label="'booking.sale-price'"  />
                </div>
                <div class="col-lg-4">
                  <Input 
                    :type="'number'"
                    :id="'booking_amount'"
                    :disabled="isMoreBooking()"
                    v-model="dataBookingAmount"
                    :last="currency"
                    :label="'booking.deposit'"  />
                </div>
                <div class="col-lg-4">
                  <Input 
                    :type="'date'"
                    :id="'expire_date'"
                    v-model="dataExpireDate"
                    :label="'booking.expired'"  />
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12">
                  <Area 
                    :rows="5"
                    :id="'notation'"
                    v-model="dataNotation"
                    :label="'booking.notation'"  />
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12">

                  <div inline class="row gy-2 gx-3 align-items-end">
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-x-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.cancel')"  />
                    </div>
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="submitSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.save')"  />
                    </div>
                  </div>
    
                </div>
              </div>
          
          </div>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                 <Dropzone 
                      :id="'doc'"
                      :maxFiles="5"
                      :label="'booking.doc'" 
                      @uploadSuccess="uploadDocSuccess" />
              </div>
            </div>

          </div>
        </div>

        <div class="card">
          <div class="card-body">
              <div class="row">
                <h4 class="card-title">{{$t('booking.booking-history')}}</h4>
              </div>
            <div class="row">
              <List v-bind:dataList="dataBookingPayments" 
                v-bind:showNo="false"
                v-bind:more="{
                  sub: [{
                    name: 'payment.receipt', icon:'bx bx-receipt', link: 'booking-payment-receipt', column: 'id', target: '_blank'
                  }]

                }"
                v-bind:filter="{}"
                v-bind:deletes="[deleted, null]"
                v-bind:updating="fetchingStats" 
                v-bind:navigate="pageNavigate"
                v-bind:formats="[{name: 'pay_date', type: 'date'}, {name: 'paid', type: 'currency', sign: '$'}]"
                v-bind:fields="[ `pay_date: ${$t('general.date')}`, `paid: ${$t('booking.amount')}`]" />
            </div>

          </div>
        </div>

      </div>
    </b-form> 

  </Layout>
</template>